import { cn } from "@repo/utils";
import type { ExplorerItem } from "../types";
import { ItemTreeNode } from "./item-tree-node";

type Props = {
  items: ExplorerItem[];
  level: number;
  onItemClick?: (item: ExplorerItem, e: React.MouseEvent) => void;
  onItemDoubleClick?: (item: ExplorerItem) => void;
  selectedItems?: Set<number>;
  disabledItemIds?: Set<number>;
  windowId?: string;
  showGroupId?: boolean;
  isDark?: boolean;
  activeItemId?: number | null;
};

export const ItemTree = ({
  items,
  level,
  onItemClick,
  onItemDoubleClick,
  selectedItems,
  disabledItemIds,
  windowId,
  showGroupId,
  isDark,
  activeItemId,
}: Props) => {
  return (
    <div
      className={cn("space-y-0.5 overflow-auto p-0.5", {
        "rounded-md bg-white/70": isDark,
      })}
    >
      {items.map((item) => (
        <ItemTreeNode
          key={item.id}
          item={item}
          level={level}
          onClick={onItemClick}
          onDoubleClick={onItemDoubleClick}
          selectedItems={selectedItems}
          disabledItemIds={disabledItemIds}
          windowId={windowId}
          showGroupId={showGroupId}
          activeItemId={activeItemId}
        />
      ))}
    </div>
  );
};
